<template>
    <div class="asternDialog">
        <el-dialog
            class="form-dialog"
            title="运输单修改"
            :visible.sync="visiable"
            :close-on-click-modal="false"
            :before-close="handleClose"
            width="680px"
        >
            <el-form
                label-position="right"
                :model="ruleForm"
                label-width="70px"
                ref="ruleForm"
                class="row-box"
            >
                <el-form-item label="发货地址" class="label-form" prop="shippingAddress">
                    <div class="clearable">
                        <otpAllAddressSelect
                            :minLayers="4"
                            v-model="ruleForm.shippingAddress"
                            placeholder="请选择四级"
                            @getAddress="getsenderAddress"
                        ></otpAllAddressSelect>
                    </div>
                    <div class="line">----</div>
                    <div class="clearable_d">
                        <el-input
                            type="textarea"
                            autosize
                            maxlength="80"
                            show-word-limit
                            clearable
                            placeholder="请输入详细地址"
                            v-model="ruleForm.senderDetailAddr"
                        ></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="收货地址"  class="label-form" prop="receivingAddress">
                    <div class="clearable">
                        <otpAllAddressSelect
                            :minLayers="4"
                            v-model="ruleForm.receivingAddress"
                            placeholder="请选择四级"
                            @getAddress="getreceivingAddress"
                        ></otpAllAddressSelect>
                    </div>
                    <div class="line">----</div>
                    <div class="clearable_d">
                        <el-input
                            type="textarea"
                            autosize
                            maxlength="80"
                            show-word-limit
                            clearable
                            v-model="ruleForm.receiverDetailAddr"
                            placeholder="请输入详细地址"
                        ></el-input>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="dialog-btn" @click="handleClose">取 消</el-button>
                <el-button class="dialog-cel" type="primary" :loading="saveLoading" @click="addOk('ruleForm')">保 存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import otpAllAddressSelect from '@/components/lots/otpCascader2';
import { changeAddress } from '../../../../api/transportDetails';
export default {
    components: { otpAllAddressSelect },
    props: {
        visiable: {
            type: Boolean,
            default: false
        },
        taskNo: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            saveLoading: false,
            ruleForm: {
                shippingAddress: [],
                senderDetailAddr: '',
                receivingAddress: [],
                receiverDetailAddr: '',
                senderProvinceCode: '',
                senderProvinceName: '',
                senderCityCode: '',
                senderCityCodeName: '',
                senderDistrictCode: '',
                senderDistrictName: '',
                senderTownCode: '',
                senderTownName: '',
                receiverProvinceCode: '',
                receiverProvinceName: '',
                receiverCityCode: '',
                receiverCityName: '',
                receiverDistrictCode: '',
                receiverDistrictName: '',
                receiverTownCode: '',
                receiverTownName: ''
            }
        };
    },
    methods: {
        handleClose() {
            this.$emit('handleClose');
        },
        getsenderAddress(labels) {
            if (labels) {
                ['senderProvinceName', 'senderCityName', 'senderDistrictName', 'senderTownName'].forEach((key, index) => {
                    this.ruleForm[key] = labels[index] || '';
                });
            }
        },
        getreceivingAddress(labels) {
            if (labels) {
                ['receiverProvinceName', 'receiverCityName', 'receiverDistrictName', 'receiverTownName'].forEach((key, index) => {
                    this.ruleForm[key] = labels[index] || '';
                });
            }
        },
        addOk(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    if (!(this.ruleForm.shippingAddress.length > 0 || this.ruleForm.receivingAddress.length > 0 || this.ruleForm.senderDetailAddr || this.ruleForm.receiverDetailAddr)) {
                        this.$message.warning('没有改动，无需保存！');
                        return;
                    }
                    try {
                        if (this.ruleForm.shippingAddress) {
                            ['senderProvinceCode', 'senderCityCode', 'senderDistrictCode', 'senderTownCode'].forEach((key, index) => {
                                this.ruleForm[key] = this.ruleForm.shippingAddress[index] || '';
                            });
                            Reflect.deleteProperty(this.ruleForm, 'shippingAddress');
                        }
                        if (this.ruleForm.receivingAddress) {
                            ['receiverProvinceCode', 'receiverCityCode', 'receiverDistrictCode', 'receiverTownCode'].forEach((key, index) => {
                                this.ruleForm[key] = this.ruleForm.receivingAddress[index] || '';
                            });
                            Reflect.deleteProperty(this.ruleForm, 'receivingAddress');
                        }
                    } finally {
                        const params = {
                            taskNo: this.taskNo,
                            ...this.ruleForm
                        };
                        this.saveLoading = true;
                        changeAddress(params).then(res => {
                            this.saveLoading = false;
                            if (res && +res.code === 0) {
                                this.$message.success('修改成功');
                                this.$emit('save');
                            }
                        }).catch(() => {
                            this.saveLoading = false;
                        });
                    }
                }
            });
        }
    }
};
</script>

<style lang="less">
.asternDialog {
    .el-form-item__label{
        font-size: 14px;
    }
    .label-form{
        .el-form-item__content{
            display: flex;
        }
         .line{
               margin-right: 5px;
               margin-left: 5px;
            }
            .el-textarea{
                width: 164%;
                position: relative;
                top: -3px;
            }
    }
    .el-input__inner{
        width: 260px;
        height: 36px;
    }
}
</style>